<template>
  <v-container
      id="contact-list"
      class="contact-list"
      fluid
      tag="section"
      style="margin-top: -15px"
  >
    <div class="md-layout">
      <v-expansion-panels
          v-model="viewExpansionPanels"
          multiple
          :style="this.showAchievement ? 'margin-top: 12px' : ''"
      >
        <v-expansion-panel>
          <v-expansion-panel-content class="panel-no-pb contact-filter">
            <v-row style="height: 50px" class="justify-space-between">
              <v-col cols="12" md="5" class="pb-0 pt-0" style="visibility: hidden;">
                <div class="text-left mb-1 mt-4">
                  <v-menu offset-y>
                    <template #activator="{ on: onMenu }">
                      <v-tooltip bottom>
                        <template #activator="{ on: onTooltip }">
                          <v-btn
                              min-width="45"
                              style="margin-right: 10px"
                              class="mb-2"
                              color="info"
                              small
                              v-on="{ ...onMenu, ...onTooltip }"
                          >
                            <v-icon>mdi-gesture-tap</v-icon>
                          </v-btn>
                        </template>

                        <span>Thao tác</span>
                      </v-tooltip>
                    </template>

                    <v-list>
                      <v-list-item
                          v-for="(action, index) in actionList"
                          :key="`${action.id}_${index}`"
                          @click="showModalAction(action.type, action.store)"
                          :style="
                          filterForm.store == 'G'
                            ? ['C', 'G'].includes(action.store)
                              ? 'display: none'
                              : ''
                            : action.store == filterForm.store
                            ? 'display: none'
                            : ''
                        "
                      >
                        <v-list-item-title>
                          {{ action.title }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <template v-if="checkAuthorization('contact_create')">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                            min-width="45"
                            v-on="on"
                            small
                            v-if="checkAuthorization('contact_create')"
                            style="margin-right: 10px"
                            color="primary"
                            dark
                            class="mb-2"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Thêm mới</span>
                    </v-tooltip>
                  </template>

                  <v-tooltip
                      bottom
                      v-if="checkAuthorization('contact_download')"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                          min-width="45"
                          v-on="on"
                          small
                          @click="chooseFile"
                          style="margin-right: 10px"
                          color="success"
                          dark
                          class="mb-2"
                      >
                        <v-icon style="margin-right: 5px"
                        >mdi-folder-upload
                        </v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>
                  <input
                      style="display: none"
                      class="file-input"
                      ref="contactFileInput"
                      type="file"
                      @input="showPopup"
                      accept=".xlsx"
                  />

                  <v-menu
                      :internal-activator="true"
                      content-class="menu__customer--filter no-contain overflow-visible"
                      :close-on-content-click="false"
                      offset-y
                  >
                    <template #activator="{ on: onMenu }">
                      <v-tooltip bottom>
                        <template #activator="{ on: onTooltip }">
                          <v-btn
                              min-width="45"
                              small
                              class="mb-2"
                              dark
                              v-on="{ ...onMenu, ...onTooltip }"
                          >
                            <v-icon>mdi-view-column</v-icon>
                          </v-btn>
                        </template>

                        <span>Cột hiển thị</span>
                      </v-tooltip>
                    </template>
                  </v-menu>

                  <v-tooltip bottom>
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                          min-width="45"
                          small
                          color="warning"
                          class="mb-2 ml-2"
                          dark
                          v-on="onTooltip"
                      >
                        <v-icon>mdi-format-align-middle</v-icon>
                      </v-btn>
                    </template>

                    <span>Ẩn/hiện mối quan hệ</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                          min-width="45"
                          small
                          color="grey"
                          class="mb-2 ml-2"
                          dark
                          v-on="onTooltip"
                      >
                        <v-icon>mdi-arrow-all</v-icon>
                      </v-btn>
                    </template>

                    <span>Ẩn/hiện chỉ số cá nhân</span>
                  </v-tooltip>

                  <template>
                    <v-menu offset-y>
                      <template #activator="{ on: onMenu }">
                        <v-tooltip bottom>
                          <template #activator="{ on: onTooltip }">
                            <v-btn
                                min-width="45"
                                class="ml-2 mb-2"
                                color="secondary"
                                dark
                                v-on="{ ...onMenu, ...onTooltip }"
                                small
                            >
                              <v-icon>mdi-format-align-bottom</v-icon>
                            </v-btn>
                          </template>

                          <span>Số dòng hiển thị</span>
                        </v-tooltip>
                      </template>
                      <v-list
                          class="s-lines-displayed"
                          style="min-width: 100px"
                      >
                        <v-list-item
                            class="lines-displayed pa-0"
                            style="cursor: pointer"
                            v-for="(item, index) in items"
                            :key="`${item.id}_${index}`"
                        >
                          <v-list-item-title class="item-lines-displayed"
                          >{{ item }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </div>
              </v-col>
              <!-- <v-col cols="12" md="1"></v-col> -->
              <v-col cols="12" md="3" class="pb-0 pt-0 mobile-hidden d-flex mt-7">
                <!-- <v-autocomplete
                  class="filter-store pt-0"
                  no-filter
                  v-model="filterForm.store"
                  :items="storeStocks"
                  placeholder="alo"
                /> -->
                <v-text-field
                    @keyup.enter="searchInterview"
                    v-model="search"
                    placeholder="Tìm kiếm theo SĐT"
                    ref="searchPhone"
                    style="
                    font-style: italic;
                    font-weight: normal;
                    font-size: 14px;
                  "
                ></v-text-field>
                <v-btn
                    width="90"
                    height="35"
                    color="primary"
                    style="margin-left: 10px"
                    @click="searchInterview"
                >Tìm kiếm
                </v-btn
                >
              </v-col>
            </v-row>
            <div
                style="width:100%;height:1px;padding:0 16px;border-top:1px solid:#BDBDBD;margin-top: 24px;border-top: 1px solid #BDBDBD;"
            ></div>
            <div class="filter-top pt-4">
              <p class="mb-0">Lọc theo</p>
              <v-row style="height:64px">
                <v-col class="d-flex justify-space-around">
                  <v-select
                      @change="checkObject"
                      solo
                      :items="subjects"
                      label="Môn học"
                      class="mr-3"
                      item-text="title"
                      clearable
                      item-value="id"
                      v-model="getFilterId.subjectId"
                  >
                  </v-select>

                  <v-select
                      solo
                      :items="allStatus.contactTutorStatus"
                      label="Trạng thái"
                      class="mr-3"
                      item-value="value"
                      item-text="text"
                      clearable
                      v-model="getFilterId.contactTutorStatusValue"
                  >
                  </v-select>
                  <div id="myDateRange">
                    <DateRangePicker
                        timePicker
                        clearable
                        clearText="Hủy"
                        okText="Chọn "
                        header-color="info"
                        :date-picker-props="dateProps"
                        @input="checkTime"
                        v-model="getFilterId.nullDatetime"
                        ref="myDateRange"
                        label="Lịch hẹn"
                    >
                    </DateRangePicker>
                  </div>

                  <v-select
                      solo
                      :items="allStatus.interviewStatus"
                      label="Phỏng vấn"
                      class="mr-3"
                      item-text="text"
                      item-value="value"
                      clearable
                      v-model="getFilterId.interviewStatusValue"
                  >
                  </v-select>

                  <v-select
                      solo
                      :items="allStatus.resultStatus"
                      label="Kết quả"
                      class="mr-3"
                      item-text="text"
                      clearable
                      item-value="value"
                      v-model="getFilterId.resultStatusValue"
                  >
                  </v-select>
                  <v-select
                      solo
                      :items="allStatus.commentStatus"
                      label="Nhận xét"
                      class="mr-3"
                      clearable
                      v-model="getFilterId.commentStatusValue"
                      item-value="value"
                      item-text="text"
                  >
                  </v-select>
                  <v-select
                      solo
                      :items="allStatus.orderState"
                      label="Đơn hàng"
                      class="mr-3"
                      clearable
                      item-text="text"
                      item-value="value"
                      v-model="getFilterId.orderStateValue"
                  >
                  </v-select>
                  <v-select
                      solo
                      :items="allStatus.orderStatus"
                      label="Trạng thái"
                      class="mr-3"
                      clearable
                      v-model="getFilterId.orderStatusId"
                      item-text="text"
                      item-value="id"
                  >
                  </v-select>
                  <v-btn
                      color="#2F80ED"
                      @click="filterListTutor"
                      class="ml-2 mt-1"
                  >
                    Bộ lọc
                  </v-btn>
                </v-col>
              </v-row>

              <!-- <v-btn
                v-bind="attrs"
                v-on="on"
                class="filter-button px-2 black--text pa-2 mr-6"
                style="
                  background: #f6f8f9;
                  border: 1px solid #6f7782;
                  border-radius: 4px;
                  padding: 0 10px !important;
                  text-transform: unset;
                "
                v-for="(titleFilter, index) in titleFilters"
                :key="index"
              >
                <span style="">{{ titleFilter }}</span>
                <v-icon color="#6F7782" style="margin-left: 10px">
                  mdi-chevron-down
                </v-icon>
              </v-btn> -->
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div class="d-flex">
      <v-card
          width="150"
          outlined
          class="rounded-lg mr-3"
          style="box-shadow: inset 0px -3px 0px #27ae60;margin-top:16px;margin-bottom:16px"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-center font-weight-medium body-2"
            >HS chờ test
            </v-list-item-title
            >
            <v-list-item-subtitle
                class="text-center"
                style="font-weight: bold; font-size: 16px; color: #172b4d"
            >
              {{ statics.today_test }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
      <v-card
          width="150"
          outlined
          class="rounded-lg mr-3"
          style="box-shadow: inset 0px -3px 0px #1599ff;margin-top:16px;margin-bottom:16px"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-center font-weight-medium body-2"
            >HS test trước mua
            </v-list-item-title
            >
            <v-list-item-subtitle
                class="text-center"
                style="font-weight: bold; font-size: 16px; color: #172b4d"
            >
              {{ statics.before_buy }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
      <v-card
          width="150"
          outlined
          class="rounded-lg mr-3"
          style="box-shadow: inset 0px -3px 0px #ff6699;margin-top:16px;margin-bottom:16px"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-center font-weight-medium body-2"
            >CR (Qua Test)
            </v-list-item-title
            >
            <v-list-item-subtitle
                class="text-center"
                style="font-weight: bold; font-size: 16px; color: #172b4d"
            >
              {{ statics.cr }} %
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </div>
    <div id="chart_center"></div>
    <div style="background: white;overflow-x: scroll;">
      <TutorTable
          :subjects="subjects"
          :listTutors="listTutors"
          :listInterview="listInterview"
          :allStatus="allStatus"
      />

      <Pagination
          v-if="showPagination"
          :totalItems="totalItems"
          :orderStatusId="getFilterId.orderStatusId"
          :commentStatusValue="getFilterId.commentStatusValue"
          :interviewStatusValue="getFilterId.interviewStatusValue"
          :contactTutorStatusValue="getFilterId.contactTutorStatusValue"
          :resultStatusValue="getFilterId.resultStatusValue"
          :subjectId="getFilterId.subjectId"
          :orderStateValue="getFilterId.orderStateValue"
          :objectId="getFilterId.objectId"
          :examsId="getFilterId.examsId"
          :getTime="getFilterId.getTime"
          :appointmentStartTime="getFilterId.nullDatetime[0]"
          :appointmentEndTime="getFilterId.nullDatetime[1]"
          :page="pages"
          :search="search"
          ref="myPagination"
      />
    </div>
  </v-container>
</template>
<script>
import RepositoryFactory from "../../repositories/RepositoryFactory";

const TestManageRepository = RepositoryFactory.get("testManage");
import TutorTable from "./components/TutorTable.vue";
import Pagination from "./components/Pagination.vue";
import DateRangePicker from "../../components/common/RangePicker.vue";

import DatetimePicker from "vuetify-datetime-picker/src/components/DatetimePicker";

export default {
  components: {TutorTable, Pagination, DateRangePicker},
  data() {
    return {
      loading: true,
      viewExpansionPanels: [0, 1],
      showAchievement: false,
      filterForm: {
        store: "",
      },
      dialog: false,
      storeStocks: [],
      items: [],
      allStatus: null,
      subjects: [],
      filterObject: [],
      listObjects: null,
      exams: [],
      getFilterId: {
        orderStatusId: null,
        commentStatusValue: null,
        interviewStatusValue: null,
        contactTutorStatusValue: null,
        resultStatusValue: null,
        subjectId: null,
        orderStateValue: null,
        objectId: null,
        examsId: null,
        nullDatetime: [],
        getTime: null,
      },
      listInterview: [],
      listTutors: [],
      statics: [],
      search: null,
      showPagination: true,
      dateProps: {
        headerColor: "#2F80ED",
      },
      totalItems: null,
      pages: 1,
    };
  },

  async created() {
    await Promise.all([
      this.getAllStatus(),
      this.getSubject(),
      this.getExam(),
      this.getStatics(),
      this.getListInterview(),
    ]);
    await this.getListTutor();
    Bus.$on("listutor-pagination", (data) => {
      this.listTutors = data;
    });
    this.helloWorld();
    this.checkRouter();
  },
  mounted() {
    let clearBtn = document.querySelector(
        "#myDateRange > div > div > div > div > span:nth-child(2)"
    );
  },
  async updated() {
  },
  beforeDestroy() {
  },
  methods: {
    async getAllStatus() {
      const response = await TestManageRepository.getAllStatus();
      this.allStatus = response.data;
    },
    async getSubject() {
      const response = await TestManageRepository.getListObject();
      this.subjects = response.data;
      Bus.$emit("subject", this.subjects);
    },
    async getExam() {
      const getListObjects = await TestManageRepository.getListObject();
      this.exams = getListObjects.data;
      const getMaths = await TestManageRepository.getMath();
      let list = getListObjects.data.filter((s) => s.alias == "tieng_anh");
    },
    showModalAction(modalType, store = "all") {
      const changeContactList = this.contacts.filter(
          (contact) => contact.checkbox
      );
      const checkContactList = [];
      changeContactList.forEach((contact) => {
        if (contact.contactType == "sub") {
          checkContactList.push(contact.mobile);
        }
      });
      if (checkContactList.length > 0) {
        return this.$swal({
          title: "Lỗi !",
          text: "Contact " + checkContactList.join(", ") + " là contact phụ.",
        });
      }
      if (changeContactList.length === 0) {
        return this.$swal({
          title: "Lỗi !",
          text: "Vui lòng chọn khách hàng !!!",
        });
      }
      if (modalType === "delete") {
        return this.deleteContacts(changeContactList);
      }
      if (modalType === "revoke") {
        return this.$swal({
          title: "Bạn muốn thu hồi các contact này",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Đồng ý",
          closeOnConfirm: false,
          cancelButtonText: "Huỷ Bỏ",
        }).then(async (result) => {
          if (result.value) {
            return this.revokeContacts(changeContactList, store);
          }
        });
      }

      if (modalType === "user" && changeContactList.length > 5) {
        return this.$swal({
          title:
              "Nếu bạn muốn thu hồi contact, hãy thực hiện thao tác thu hồi trước!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "OK",
          closeOnConfirm: false,
          cancelButtonText: "Không",
        }).then(async (result) => {
          if (!result.value) {
            return (this.filterForm.modalType = modalType);
          }
        });
      }
      this.filterForm.modalType = modalType;
    },
    showPopup() {
      this.$swal({
        title: "Upload data",
        text: "Bạn có thực sự chắc chắn ?",
        confirmButtonText: "Đồng ý",
        showCancelButton: true,
        cancelButtonText: "Hủy bỏ",
      }).then(async (res) => {
        if (res.value) {
          await this.onSelectContactFile();
        } else {
          this.$refs.contactFileInput.value = "";
        }
      });
    },
    checkTime() {
      let label = document.querySelector("#myDateRange > div > label");
      label.style.display = "none";
      if (this.getFilterId.nullDatetime.length == 0) {
        label.style.display = "block";
      }
      let startHour = document.querySelector(
          "#myDateRange > div > div > div.daterangepicker.dropdown-menu.ltr.show-calendar.show-ranges.show-weeknumbers.linked > div > div.calendars-container > div.drp-calendar.col.left > div.calendar-time > select.hourselect.form-control.mr-1"
      );
      let minutes = document.querySelector(
          "#myDateRange > div > div > div.daterangepicker.dropdown-menu.ltr.show-calendar.show-ranges.show-weeknumbers.linked > div > div.calendars-container > div.drp-calendar.col.left > div.calendar-time > select.minuteselect.form-control.ml-1"
      );

      // label.style.display = "none";
      //  console.log(this.getFilterId.nullDatetime)
      //   const day = this.getFilterId.nullDatetime.getDate();
      //   const month = this.getFilterId.nullDatetime.getMonth() + 1;
      //   const year = this.getFilterId.nullDatetime.getFullYear();
      //   const hour = this.getFilterId.nullDatetime.getHours();
      //   const minutes = this.getFilterId.nullDatetime.getMinutes();
      //   const second = this.getFilterId.nullDatetime.getSeconds();
      //   const time =
      //     year +
      //     "-" +
      //     (month < 10 ? `0${month}` : month) +
      //     "-" +
      //     (day < 10 ? `0${day}` : day) +
      //     " " +
      //     (hour < 10 ? `0${hour}` : hour) +
      //     ":" +
      //     (minutes < 10 ? `0${minutes}` : minutes) +
      //     ":" +
      //     "00";
      //   this.getFilterId.getTime = time;
    },
    helloWorld() {
      let clearTimeBtn = document.querySelector(
          ".v-application .grey--text.text--lighten-1"
      );
    },

    async getStatics() {
      const paramsStatic = {
        subjectId: this.getFilterId.subjectId,
        startTime: this.getFilterId.nullDatetime[0],
        endTime: this.getFilterId.nullDatetime[1],
      };
      const responseStatic = await TestManageRepository.getStatistics(
          paramsStatic
      );
      if (responseStatic.success) {
        this.statics = responseStatic.data;
      }
    },
    async getListTutor() {
      // this.pages = 1

      const loader = this.$loading.show();
      const paramsStatic = {
        subjectId: this.getFilterId.subjectId,
        startTime: this.getFilterId.nullDatetime[0],
        endTime: this.getFilterId.nullDatetime[1],
      };
      const params = {
        // page: 0,
        // limit: 10,
        appointmentStartTime: this.getFilterId.nullDatetime[0],
        appointmentEndTime: this.getFilterId.nullDatetime[1],
        // gradeId,
        status: this.getFilterId.contactTutorStatusValue,
        interviewStatus: this.getFilterId.interviewStatusValue,
        level: this.getFilterId.examsId,
        subjectId: this.getFilterId.subjectId,
        commentStatus: this.getFilterId.commentStatusValue,
        orderStatus: this.getFilterId.orderStatusId,
        orderState: this.getFilterId.orderStateValue,
        resultStatus: this.getFilterId.resultStatusValue,
        search: this.search,
      };

      const response = await TestManageRepository.getListTutor(params);
      const responseStatic = await TestManageRepository.getStatistics(
          paramsStatic
      );
      if (responseStatic.success) {
        this.statics = responseStatic.data;
      }
      loader.hide();
      if (response.success) {
        let listTutors = _.get(response, "data.data", []);
        this.totalItems = response.data.totalItem;
        listTutors = listTutors.map((i) => {
          return {
            ...i,
            showDate: false,
            showDialog: false,
            showPopup: false,
          };
        });

        this.listTutors = listTutors;
      }
    },
    async filterListTutor() {

      const loader = this.$loading.show();
      const paramsStatic = {
        subjectId: this.getFilterId.subjectId,
        startTime: this.getFilterId.nullDatetime[0],
        endTime: this.getFilterId.nullDatetime[1],
      };
      const params = {
        // page: 0,
        // limit: 10,
        appointmentStartTime: this.getFilterId.nullDatetime[0],
        appointmentEndTime: this.getFilterId.nullDatetime[1],
        // gradeId,
        status: this.getFilterId.contactTutorStatusValue,
        interviewStatus: this.getFilterId.interviewStatusValue,
        level: this.getFilterId.examsId,
        subjectId: this.getFilterId.subjectId,
        commentStatus: this.getFilterId.commentStatusValue,
        orderStatus: this.getFilterId.orderStatusId,
        orderState: this.getFilterId.orderStateValue,
        resultStatus: this.getFilterId.resultStatusValue,
        search: this.search,
      };

      const response = await TestManageRepository.getListTutor(params);
      const responseStatic = await TestManageRepository.getStatistics(
          paramsStatic
      );
      if (responseStatic.success) {
        this.statics = responseStatic.data;
      }
      loader.hide();
      if (response.success) {
        let listTutors = _.get(response, "data.data", []);
        this.totalItems = response.data.totalItem;
        listTutors = listTutors.map((i) => {
          return {
            ...i,
            showDate: false,
            showDialog: false,
            showPopup: false,
          };
        });

        this.listTutors = listTutors;
      }
      this.$refs.myPagination.page = 1
    },
    async getListInterview() {
      const response = await TestManageRepository.getListUser();
      this.listInterview = response.data;
    },
    async searchInterview() {
      const loader = this.$loading.show();
      const params = {
        search: this.search,
      };
      const response = await TestManageRepository.getListTutor(params);
      if (response.success) {
        this.listTutors = _.get(response, "data.data", []);
        this.totalItems = response.data.totalItem;
      }
      Bus.$emit("list-dash", this.listTutors);
      this.$refs.myPagination.page = 1
      loader.hide();
    },
    updateDatePicker(a) {
    },
    pickerDateRange(e) {
      let label = (document.querySelector(
          "#myDateRange .s-datepicker-range label"
      ).innerHTML = "");
    },
    checkRouter() {
      if (this.$route.params.id) {
        this.search = this.$route.params.id;
        this.searchInterview();
      }
    },
  },
  computed: {
    getObjects() {
      return this.subjects.map((s) => s.title);
    },
    actionList() {
      const actionList = [];
      if (this.checkAuthorization("contact_change_status_read")) {
        actionList.push({
          title: "Chuyển mối quan hệ",
          type: "status",
          store: "all",
        });
      }
      if (this.checkAuthorization("contact_change_user_read")) {
        actionList.push({
          title: "Chuyển người phụ trách",
          type: "user",
          store: "all",
        });
      }
      if (this.checkAuthorization("contact_update")) {
        actionList.push({
          title: "Thêm nhóm sản phẩm",
          type: "productGroup",
          store: "all",
        });
        actionList.push({
          title: "Chuyển nhóm ngành",
          type: "schoolLevel",
          store: "all",
        });
      }
      if (this.checkAuthorization("contact_move_to_cc_read")) {
        actionList.push({
          title: "Thu hồi contacts trở lại Kho T",
          type: "revoke",
          store: "T",
        });
        actionList.push({
          title: "Thu hồi contacts về Kho C",
          type: "revoke",
          store: "C",
        });
        actionList.push({
          title: "Thu hồi contacts về Kho G",
          type: "revoke",
          store: "G",
        });
        // actionList.push({ title: 'Thu hồi contacts về Kho M', type: 'revoke', store: 'M' });
      }
      if (this.checkAuthorization("contact_move_to_m_read")) {
        actionList.push({
          title: "Thu hồi contacts về Kho M",
          type: "revoke",
          store: "M",
        });
      }
      if (this.checkAuthorization("contact_delete")) {
        actionList.push({title: "Xoá", type: "delete", store: "all"});
      }
      return actionList;
    },
    filterSearch() {
      return this.listInterview.filter((post) => {
        return post.fullName.toLowerCase().includes("t");
      });
    },
    checkObject() {
      return "";
    },
  },
};
</script>

<style scoped lang="css">
#contact-list {
  padding-bottom: 0px;
}

.v-expansion-panel::before {
  box-shadow: none;
}

.c-pagination .v-pagination__navigation {
  height: 28px;
  width: 28px;
}

.c-pagination .v-pagination__item {
  height: 28px;
  min-width: 28px;
  font-size: 12px;
}

.lines-displayed {
  min-height: auto;
}

.lines-displayed .item-lines-displayed {
  width: 100%;
  padding: 8px 15px;
  margin: 4px 0px;
  cursor: pointer;
}

.lines-displayed .item-lines-displayed:hover {
  background: #d2d2d2;
}

.filter-store input {
  font-size: 13px !important;
}

.report-achievement .v-expansion-panel-content__wrap {
  padding: 0;
}

.pagination-btn-left,
.pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}

.pagination-btn-left i,
.pagination-btn-right i {
  color: rgba(0, 0, 0, 0.54) !important;
}

.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}

.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}

.panel-no-pb .v-expansion-panel-content__wrap {
  padding-bottom: 0px;
}

.v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding-left: 15px;
  padding-right: 15px;
}

.s-table-contact.v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 0px;
}

.filter-top {
  padding-top: 24px;
}

.filter-button:last-child {
  background: #2f80ed !important;
  width: 194px !important;
  margin-right: 0 !important;
  border: none !important;
  color: #ffffff !important;
}

.filter-button:last-child.v-btn__content.v-icon {
  display: none !important;
}

.box-test {
  width: 150px;
  height: 99px;
  background: #ffffff;

  border-radius: 6px;
  margin-top: 25px;
}

.box-test span {
  color: #172b4d;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}

#pickDate {
  margin-right: 12px;
  width: 210px;
  height: 48px;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 1px -2px,
  rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px !important;
  cursor: pointer;
}

.v-select .v-select__selections {
  text-transform: initial !important;
}

/deep/ .s-datepicker-range {
  width: 168px !important;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 1px -2px,
  rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px !important;
  height: 48px !important;
  margin-right: 12px !important;
  margin-top: unset !important;
  padding-left: 12px !important;
  /* label {
    font-weight: 400;
    font-size: 14px;
  } */
}

/deep/ .s-datepicker-range label {
  font-weight: 400 !important;
  font-size: 14px !important;
  top: 14px !important;
  margin-left: 12px;
  z-index: 10;
}

/deep/ .reportrange-text {
  margin-top: 12px !important;
  border: unset !important;
}

#myDateRange {
  /* margin-right: 12px; */
  width: 210px !important;
}

/deep/ #myDateRange > .v-text-field--is-booted .v-input__control .v-input__slot {
  border: 1px solid #d9dbe9 !important;
  height: 48px !important;
  padding: 0 12px !important;
  border-radius: 4px !important;
  box-shadow: rgb(0 0 0 / 20%) 0px 3px 1px -2px,
  rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px !important;
}

/deep/ .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #d9dbe9 !important;
}

/deep/ .v-text-field--is-booted {
  padding-top: unset !important;
  margin-top: unset !important;
}

/deep/
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
> .v-input__control
> .v-input__slot
fieldset {
  border: 1px !important;
}

#contact-list
> div.md-layout
> div
> div
> div
> div
> div.row
> div.pb-0.pt-0.mobile-hidden.d-flex.col-md-3.col-12 {
  margin-top: 13px;
}

.v-application .primary--text {
  color: unset !important;
}

/deep/ #myDateRange .show-calendar {
  min-width: 700px !important;
}

/* /deep/ #myDateRange > div > div > div > div > span {
  display: none !important;
} */
</style>
